const gtag = (...args) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag(...args);
  }
};

export const trackEvent = (eventName, params = {}) => {
  gtag("event", eventName, params);
};

export const trackPhoneClick = (location = "unknown") => {
  gtag("event", "phone_call_click", {
    event_category: "contact",
    event_label: location,
  });
};

export const trackWhatsAppClick = (location = "unknown") => {
  gtag("event", "whatsapp_click", {
    event_category: "contact",
    event_label: location,
  });
};

export const trackFormSubmission = (formName = "quote_form") => {
  gtag("event", "generate_lead", {
    event_category: "conversion",
    event_label: formName,
  });
};

export const trackCTAClick = (label, destination = "") => {
  gtag("event", "cta_click", {
    event_category: "engagement",
    event_label: label,
    link_url: destination,
  });
};

// Call once from App.js to track all tel: link clicks site-wide
export const installPhoneClickTracker = () => {
  document.addEventListener("click", (e) => {
    const link = e.target.closest("a[href^='tel:']");
    if (link) {
      const location = link.closest("[data-page]")?.dataset.page || document.title;
      trackPhoneClick(location);
    }
  });
};
